<template>
    <div
            v-if="count"
            class="badge"
            :style="{
                'top': top+'px',
                'right': right+'px',
                'min-width': size+'px',
                'height': size+'px',
                'font-size': fontSize+'px',
                'line-height': fontSize+'px',
            }"
    >{{ count }}</div>
</template>

<script>
    export default {
        props: {
            top: {type: Number, default: 2},
            right: {type: Number, default: 0},
            count: {type: Number, default: null},
            size: {type: Number, default: 20},
            fontSize: {type: Number, default: 12},
        }
    }
</script>

<style lang="scss">
    @import 'src/assets/scss/vars';

    .badge {
        background-color: rgb(255 0 0 / 60%);
        color: #fff;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 3px;
        position: absolute;
    }
</style>